// 2019-2020 半财年
const beijing2019 = resolve => require(['./beijing/2019.vue'], resolve)
const shanghai2019 = resolve => require(['./shanghai/2019'], resolve)
const nanjing2019 = resolve => require(['./nanjing/2019'], resolve)
const suzhou2019 = resolve => require(['./suzhou/2019'], resolve)
const chengdu2019 = resolve => require(['./chengdu/2019'], resolve)
const hangzhou2019 = resolve => require(['./hangzhou/2019'], resolve)
const xiamen2019 = resolve => require(['./xiamen/2019'], resolve)
const shenzhen2019 = resolve => require(['./shenzhen/2019'], resolve)
const wuhan2019 = resolve => require(['./wuhan/2019'], resolve)
const guangzhou2019 = resolve => require(['./guangzhou/2019'], resolve)
const taibei2019 = resolve => require(['./taibei/2019'], resolve)

// 2020 全财年
const beijing2020 = resolve => require(['./beijing/2020'], resolve)
const shanghai2020 = resolve => require(['./shanghai/2020'], resolve)
const nanjing2020 = resolve => require(['./nanjing/2020'], resolve)
const suzhou2020 = resolve => require(['./suzhou/2020'], resolve)
const chengdu2020 = resolve => require(['./chengdu/2020'], resolve)
const hangzhou2020 = resolve => require(['./hangzhou/2020'], resolve)
const xiamen2020 = resolve => require(['./xiamen/2020'], resolve)
const shenzhen2020 = resolve => require(['./shenzhen/2020'], resolve)
const wuhan2020 = resolve => require(['./wuhan/2020'], resolve)
const guangzhou2020 = resolve => require(['./guangzhou/2020'], resolve)

// 2021 全财年
const beijing2021 = resolve => require(['./beijing/2021'], resolve)
const shanghai2021 = resolve => require(['./shanghai/2021'], resolve)
const nanjing2021 = resolve => require(['./nanjing/2021'], resolve)
const suzhou2021 = resolve => require(['./suzhou/2021'], resolve)
const chengdu2021 = resolve => require(['./chengdu/2021'], resolve)
const hangzhou2021 = resolve => require(['./hangzhou/2021'], resolve)
const xiamen2021 = resolve => require(['./xiamen/2021'], resolve)
const shenzhen2021 = resolve => require(['./shenzhen/2021'], resolve)
const wuhan2021 = resolve => require(['./wuhan/2021'], resolve)
const guangzhou2021 = resolve => require(['./guangzhou/2021'], resolve)

// 2022 全财年
const beijing2022 = resolve => require(['./beijing/2022'], resolve)
const shanghai2022 = resolve => require(['./shanghai/2022'], resolve)
const nanjing2022 = resolve => require(['./nanjing/2022'], resolve)
const suzhou2022 = resolve => require(['./suzhou/2022'], resolve)
const chengdu2022 = resolve => require(['./chengdu/2022'], resolve)
const hangzhou2022 = resolve => require(['./hangzhou/2022'], resolve)
const xiamen2022 = resolve => require(['./xiamen/2022'], resolve)
const shenzhen2022 = resolve => require(['./shenzhen/2022'], resolve)
const wuhan2022 = resolve => require(['./wuhan/2022'], resolve)
const guangzhou2022 = resolve => require(['./guangzhou/2022'], resolve)

// 2023 全财年
const beijing2023 = resolve => require(['./beijing/2023'], resolve)
const shanghai2023 = resolve => require(['./shanghai/2023'], resolve)
const nanjing2023 = resolve => require(['./nanjing/2023'], resolve)
const suzhou2023 = resolve => require(['./suzhou/2023'], resolve)
const chengdu2023 = resolve => require(['./chengdu/2023'], resolve)
const hangzhou2023 = resolve => require(['./hangzhou/2023'], resolve)
const xiamen2023 = resolve => require(['./xiamen/2023'], resolve)
const shenzhen2023 = resolve => require(['./shenzhen/2023'], resolve)
const wuhan2023 = resolve => require(['./wuhan/2023'], resolve)
const guangzhou2023 = resolve => require(['./guangzhou/2023'], resolve)
const silicon2023 = resolve => require(['./silicon/2023'], resolve)
const singapore2023 = resolve => require(['./singapore/2023'], resolve)

export default {
  beijing2019,
  shanghai2019,
  nanjing2019,
  suzhou2019,
  chengdu2019,
  hangzhou2019,
  xiamen2019,
  shenzhen2019,
  wuhan2019,
  guangzhou2019,
  taibei2019,

  beijing2020,
  shanghai2020,
  nanjing2020,
  suzhou2020,
  chengdu2020,
  hangzhou2020,
  xiamen2020,
  shenzhen2020,
  wuhan2020,
  guangzhou2020,

  beijing2021,
  shanghai2021,
  nanjing2021,
  suzhou2021,
  chengdu2021,
  hangzhou2021,
  xiamen2021,
  shenzhen2021,
  wuhan2021,
  guangzhou2021,

  beijing2022,
  shanghai2022,
  nanjing2022,
  suzhou2022,
  chengdu2022,
  hangzhou2022,
  xiamen2022,
  shenzhen2022,
  wuhan2022,
  guangzhou2022,

  beijing2023,
  shanghai2023,
  nanjing2023,
  suzhou2023,
  chengdu2023,
  hangzhou2023,
  xiamen2023,
  shenzhen2023,
  wuhan2023,
  guangzhou2023,

  silicon2023,
  singapore2023
}
